import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { useLocation, useNavigate } from "react-router-dom";

/**
 * ViewBank component displays user-entered and bank-verified details for review.
 * Provides navigation and formatted display of bank information.
 */
const ViewBank = ({ login = null }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const bankdetails = location.state?.bankdetails || {};
  const uservalue = location.state?.uservalue || {};
  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .replace(/nameAtBank/g, "Name at Bank")
      .replace(/bankName/g, "Bank Name")
      .replace(/refId/g, "Ref Id")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">Bank Details are valid</h6>
            </div>

            <div className="px-2">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <div className="d-flex invalid_bankdata mb-5">
                <div className="invaild_data">
                  <label>Name at Bank</label>
                  <p>{uservalue.name_of_bank}</p>
                </div>

                <div className="invaild_data">
                  <label>Account Number</label>
                  <p>{uservalue.account_number}</p>
                </div>

                <div className="invaild_data">
                  <label>IFSC Code</label>
                  <p>{uservalue.ifsc_code}</p>
                </div>
              </div>
            </div>

            <div className="card_data bank_invliddata">
              <h6>Details As Per The Bank Details</h6>
              <ul className="details_card d-flex flex-wrap">
                {Object.entries(bankdetails).map(([key, value]) => (
                  <li key={key}>
                    <label>{formatKey(key)}:</label> <p>{value}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              {/* <Link to={`${redirectUrl}/addbank-account/${userId}`}> */}
              <button className="btn bgdark-blue text-white" onClick={() => navigate(-1)}>Back</button>
              {/* </Link> */}
              {/* <Link to={`${redirectUrl}/bankdetails-added/${userId}`}>
              <button className="btn red-btn text-white">Submit</button>
            </Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewBank